import { Button } from "antd";
import styled, { css } from "styled-components";
import { useDisableCookies } from "../hooks/useDisableCookies";
import { VFC } from "react";

export const Legal: VFC<{ fixed?: boolean }> = ({ fixed }) => {
  const disableCookies = useDisableCookies("cookiesAccepted");

  return (
    <StyledLegal fixed={fixed}>
      <Button
        size={"small"}
        type={"link"}
        target={"_blank"}
        href={"https://mayasolutions.de/impressum"}
      >
        Impressum
      </Button>
      <Button
        size={"small"}
        type={"link"}
        target={"_blank"}
        href={
          "https://mayasolutions.de/datenschutzerklaerung-fuer-werbinich-web-app"
        }
      >
        Datenschutz
      </Button>{" "}
      <Button
        size={"small"}
        type={"link"}
        target={"_blank"}
        href={"https://mayasolutions.de/nutzungsbedingungen-werbinich-web-app"}
      >
        Nutzungsbedingungen
      </Button>{" "}
      <Button size={"small"} type={"link"} onClick={() => disableCookies()}>
        Cookies zurücksetzen
      </Button>
    </StyledLegal>
  );
};

const StyledLegal = styled.div<{ fixed?: boolean }>`
  ${(props) =>
    props.fixed &&
    css`
      z-index: 30;
      position: fixed;
      bottom: 0px;
      display: block;
      background-color: #f0f2f5;
    `}
`;
